import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const PeopleModule = ({
  key,
  heading=null,
  backgroundColor="white",
  caption=null,
  people=null
}) => {
  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';
  return (
    <div className={ `col-12 people-block bg-${backgroundColor}` }>
      <div className="container">
        {(heading || caption) &&
          <div className="heading">
            <div className="col-10 col-md-7 col-lg-6 tac">
              {heading &&
                <h2>{ htmlDecode(heading) }</h2>
              }
              {caption &&
                <div className="section-content" dangerouslySetInnerHTML={{ __html: caption }} />
              }
            </div>
          </div>
        }
        <div className="col-xs-16 col-sm-14 offset-sm-1">
          <div className="row">
            {people && people.map((person, index) => (
              <div className={ `col-12 col-md-6 pt7 leadership-block ${(index + 1) % 2 === 0 ? "pl4" : "pr4"}` }>
                <div className="col-12 leadership-header">
                  {person.featuredImage &&
                    <div className="lead-img">
                      {person.featuredImage?.formats?.medium &&
                        <img src={ `${person.featuredImage.formats.medium.url.includes(cdnUrl) ? person.featuredImage.formats.medium.url : cdnUrl + person.featuredImage.formats.medium.url }` } alt={ person.featuredImage?.alternativeText } className="img-circle" />
                      }
                      {!person.featuredImage?.formats?.medium &&
                        <img src={ `${person.featuredImage.url.includes(cdnUrl) ? person.featuredImage.url : cdnUrl + person.featuredImage.url}` } alt={ person.featuredImage?.alternativeText } className="img-circle" />
                      }
                    </div>
                  }
                  <div className="lead-info">
                    {person.name &&
                      <h2 className="leadership-title">{ htmlDecode(person.name) }</h2>
                    }
                    {person.leadershipPositionTitle &&
                      <h3 className="leadership-subtitle">{ htmlDecode(person.leadershipPositionTitle) }</h3>
                    }
                    {person.linkedInUrl &&
                      <Link href={ person.linkedInUrl } target="_blank" className="leadership-social-icon"><i className="social fa fa-linkedin"></i></Link>
                    }
                    {person.twitterUrl &&
                      <Link href={ person.twitterUrl } target="_blank" className="leadership-social-icon"><i className="social fa fa-twitter"></i></Link>
                    }
                  </div>
                </div>
                <div className="col-12">
                  {person.testimonial &&
                    <div className="section-content" dangerouslySetInnerHTML={{ __html: person.testimonial }} />
                  }
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PeopleModule
